import { h } from 'preact'
import { getChildCategories, getCategoryPlaceholder } from './utils'
import ButtonControl from '../button-control'
import Icon from '../assets'
import PublishedInFilterSelector from '../overview/filters/PublishedInFilterSelector'

interface FilterData {
    id: string,
    name: string,
    customClassName: string,
    title: string,
    isDropdownOpen: boolean,
    toggleDropdown: (value: boolean) => void,
    resetDropdown: () => void,
    onClear: (e: Event) => void,
    onChange: (data: any) => void,
    items: any,
    selectedItems: Array<string>,
    isLoading: boolean
}

interface PlaceholderText {
    text?: string,
    additionalText?: string
}

const DashboardCategoryFilter = ({ id, name, customClassName, title, isDropdownOpen, toggleDropdown, resetDropdown, items, selectedItems, onClear, onChange, isLoading }: FilterData) => {
  const categories = getChildCategories(items)
  const placeholderAdditionalText : PlaceholderText = getCategoryPlaceholder(categories, selectedItems)
  return (
    <div className={`filter-option filter-option-${customClassName}`}>
      <ButtonControl newStyle disabled={isLoading}
        title={<FilterTitle title={title} onClear={onClear} placeholder={placeholderAdditionalText} selectedItems={selectedItems} />}
        size='medium'
        class={`${customClassName}-open-button filter-option-button ${isDropdownOpen ? 'dropdown-open' : ''} `}
        onClick={() => toggleDropdown(!isDropdownOpen)} />
      {isDropdownOpen &&
        <div className='overview__filters-box-container'>
          <div className='overview__filters-box'>
            <PublishedInFilterSelector id={id} name={name} isSearchable items={items} selectedFilterItems={selectedItems} disableApplyButton={false}>
              {({ isApplyButtonDisabled, data }: { isApplyButtonDisabled: boolean, data: any }) =>
                <div>
                  <hr />
                  <div className='overview__filters-box-buttons'>
                    <ButtonControl
                      newStyle
                      size='small'
                      variant='brand'
                      title='Apply'
                      disabled={isApplyButtonDisabled}
                      onClick={() => onChange(data)} />
                    <ButtonControl newStyle size='small' title='Cancel' onClick={resetDropdown} />
                  </div>
                </div>
              }
            </PublishedInFilterSelector>
          </div>
        </div>}
    </div>)
}

interface FilterTitleProps {
    title: string,
    placeholder: PlaceholderText,
    onClear: (e: Event) => void,
    selectedItems: Array<string>
}

const FilterTitle = ({ title, placeholder, onClear, selectedItems }: FilterTitleProps) => (
  <div className='dropdown-filter-title'>
    <div className='dropdown-placeholder-text'> {title}</div>
    <div className='dropdown-selected-placeholder'>{placeholder?.text}</div>
    {placeholder?.additionalText && <div className='dropdown-selected-placeholder-additional-text'>
      {placeholder?.additionalText}
    </div>}
    {selectedItems.length > 0
      ? <div className='icon-cancel-wrapper' onClick={(e) => onClear(e)}>
        <Icon icon='cancel' customClass='icon-cancel' height={16} width={16} /> </div> : null}</div>
)

export default DashboardCategoryFilter
